/**
 * Node3D property formatter - formats transform properties for display.
 */
import { decomposeTransform3D, formatDegrees } from '../../../utils/transform';
export function formatNode3DProperties(properties) {
    const sections = [];
    if (properties.transform) {
        const { position, rotation, scale } = decomposeTransform3D(properties.transform);
        sections.push({
            title: 'Position',
            items: [
                { label: 'X', value: position.x.toFixed(3) },
                { label: 'Y', value: position.y.toFixed(3) },
                { label: 'Z', value: position.z.toFixed(3) },
            ],
        });
        sections.push({
            title: 'Rotation (degrees)',
            items: [
                { label: 'X', value: formatDegrees(rotation.x) },
                { label: 'Y', value: formatDegrees(rotation.y) },
                { label: 'Z', value: formatDegrees(rotation.z) },
            ],
        });
        sections.push({
            title: 'Scale',
            items: [
                { label: 'X', value: scale.x.toFixed(3) },
                { label: 'Y', value: scale.y.toFixed(3) },
                { label: 'Z', value: scale.z.toFixed(3) },
            ],
        });
    }
    if (properties.instance) {
        sections.push({
            title: 'Instance',
            items: [{ label: 'Scene', value: properties.instance }],
        });
    }
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map